import MojitoCore from 'mojito/core';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';
import DateTimeFormatter from 'presentation/formatters/date-time/index.js';
import FixedWidthTime from 'presentation/components/fixed-width-time/index.js';

const { UIViewImplementation } = MojitoCore.Presentation;
const isShallowEqual = MojitoCore.Base.objUtils.isShallowEqual;
const clockTicker = MojitoCore.Base.clockTicker;

export default class Clock extends UIViewImplementation {
    constructor(props) {
        super(props);
        this.state = {
            currentUTC: new Date(),
        };
        this.onClockTick = this.onClockTick.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isShallowEqual(this.props, nextProps) || !isShallowEqual(this.state, nextState);
    }

    componentDidMount() {
        clockTicker.addListener(this.onClockTick);
    }

    componentWillUnmount() {
        clockTicker.removeListener(this.onClockTick);
    }

    onClockTick() {
        const currentUTC = new Date();
        if (this.state.currentUTC.getSeconds() !== currentUTC.getSeconds()) {
            this.setState({ currentUTC });
        }
    }

    renderOffset() {
        if (this.config.isOffsetHidden) {
            return null;
        }
        const offsetValueFormat =
            this.props.timeOffset >= 0 ? `+${this.props.timeOffset}` : this.props.timeOffset;
        return (
            <Text config={this.config.offset} class="offset">
                {this.resolveAndFormatString('$CLOCK.OFFSET_FORMAT', offsetValueFormat)}
            </Text>
        );
    }

    render() {
        const userSettings = this.appContext().userSettings();
        const { language } = this.appContext().systemSettings();
        const { currentUTC } = this.state;
        const { timeFormat } = this.config;
        const timeStr = DateTimeFormatter.formatDateTime(
            currentUTC,
            timeFormat,
            userSettings,
            language
        );
        return (
            <FlexPane config={this.config.container} class={`ta-Clock ${this.props.class || ''}`}>
                <FixedWidthTime config={this.config.time} time={timeStr} class="time" />
                {this.renderOffset()}
            </FlexPane>
        );
    }
}
